import { AddToCartItem, ProductBuilderMachineContext } from '../types';

type RollerblindAddonProducts = (
  context: ProductBuilderMachineContext,
  upi: string,
  roomName: string,
  parentProductTitle: string,
) => AddToCartItem[];

export const getRomanAddonProducts: RollerblindAddonProducts = (
  {
    measureInsurance: measureInsuranceAddonProducts,
    extensionPole: extensionPoleAddonProducts,
    stainlessSteelChain: stainlessSteelChainAddonProducts,
    quantity,
    custom: { measureInsurance, extensionPole, stainlessSteelChain },
  },
  upi,
  roomName,
  parentProductTitle,
) => {
  return measureInsuranceAddonProducts
    .concat(extensionPoleAddonProducts)
    .concat(stainlessSteelChainAddonProducts)
    .filter(({ first_available_variant: { id } }) => {
      const isMeasureInsurance = id === measureInsurance;
      const isExtensionPole = id === extensionPole;
      const isStainlessSteelChain = id === stainlessSteelChain;
      return isMeasureInsurance || isExtensionPole || isStainlessSteelChain;
    })
    .map(({ first_available_variant: { id } }) => {
      const isMeasureInsurance = id === measureInsurance;
      const isExtensionPole = id === extensionPole;
      const isStainlessSteelChain = id === stainlessSteelChain;

      return {
        quantity:
          isMeasureInsurance || isExtensionPole || isStainlessSteelChain
            ? 1
            : quantity,
        id,
        properties: !isMeasureInsurance
          ? {
              _upi: upi,
              'Product for': `${parentProductTitle} - Room: ${roomName}`,
            }
          : {
              _upi: '',
              'Product for': `${parentProductTitle} - Room: ${roomName}`,
            },
      };
    });
};
